import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastProvider } from '../../components/ui/Toast';
import { StudentAuthProvider, useStudentAuth } from '../../contexts/StudentAuthContext';
import Spinner from '../../components/ui/Spinner';
import StudentLogin from './StudentLogin';
import StudentClaim from './StudentClaim';
import StudentDashboard from './StudentDashboard';

function StudentProtected({ children }) {
  const { student, loading } = useStudentAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-stone-600">
        <Spinner size="lg" className="text-amber-800 h-8 w-8" />
        <p className="text-sm">Loading…</p>
      </div>
    );
  }
  if (!student) return <Navigate to="/student/login" replace />;
  return children;
}

function StudentRoutes() {
  return (
    <Routes>
      <Route path="/student" element={<Navigate to="/student/dashboard" replace />} />
      <Route path="/student/login" element={<StudentLogin />} />
      <Route path="/student/claim" element={<StudentClaim />} />
      <Route
        path="/student/dashboard"
        element={(
          <StudentProtected>
            <StudentDashboard />
          </StudentProtected>
        )}
      />
      <Route path="*" element={<Navigate to="/student/login" replace />} />
    </Routes>
  );
}

/** Isolated student app shell — mounted only on student.prosperityleaders.net */
export default function StudentApp() {
  return (
    <StudentAuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <StudentRoutes />
        </BrowserRouter>
      </ToastProvider>
    </StudentAuthProvider>
  );
}
